<template>
  <div class="add" v-if="isLoaded">
    <!-- <add-ut /> -->
    <h1>{{ utData.testName }}</h1>
    <div class="bridge-content">
      <template v-if="!isEnd">
        <h2><span>내용</span></h2>
        <p v-html="utData.contents"></p>
        <div class="question-cont" v-if="utData.surveyInfo.question.length > 0">
          <h2><span>문항</span></h2>

          <template v-for="(question, index) in utData.surveyInfo.question">
            <div v-bind:key="index">
              <h5 :class="{'mT100' : index !== 0}">
                <span>{{ index + 1 }}.</span>
                {{ question.subject }}
              </h5>

              <template v-for="(item, itemIndex) in question.items">
                <component
                  v-bind:key="itemIndex"
                  :is="'ui-' + question.itemType"
                  :checkText="item"
                  :checkLabel="question.itemType + index + 'Id' + itemIndex"
                  :checkName="question.itemType + index + 'Name'"
                  :radioText="item"
                  :radioLabel="question.itemType + index + 'Id' + itemIndex"
                  :radioName="question.itemType + index + 'Name'"
                  :inputValue="itemIndex"
                  :index="itemIndex"
                  :parentIndex="index"
                  v-model="saveUtData.surveyData[index]"
                />

              </template>
              <p class="error-txt" v-if="modelError.question[index]">설문 응답이 필요합니다.</p>
            </div>
          </template>
        </div>
        <div class="information-cont">
          <p class="error-txt" v-if="modelError.privacyAgree || modelError.thirdPartyAgree">모든 약관 동의가 필요합니다.</p>
          <ul>
            <li>
              <ui-checkbox :value="isPrivacyAgree" :checkLabel="'privacy_checkbox'" :checkText="'개인정보 수집 및 이용 동의'" :contList="'information'" @input="onClickPrivacyAgree"/>
              <button-item :btnText="'자세히 보기'" :btnClass="'information'" @click="onClickAgreement('privacy_checkbox')" />
            </li>
            <li>
              <ui-checkbox :value="isThirdPartyAgree" :checkLabel="'third_checkbox'" :checkText="'제 3자 정보제공 동의'" :contList="'information'" @input="onClickThirdPartyAgree"/>
              <button-item :btnText="'자세히 보기'" :btnClass="'information'"  @click="onClickAgreement('third_checkbox')" />
            </li>
          </ul>
        </div>
      </template>

      <template v-else>
        <div class="cont-none">
          <h2>{{ utData.testName }}</h2>
          <img src="@/assets/images/visual-test-and.svg" alt="">
          <h3>종료된 테스트입니다.</h3>
          <p>관련 문의 : {{utData.contact}}</p>
        </div>
      </template>
    </div>
    <div class="btn-clear-position" v-if="!isEnd">
      <button-item :btnText="'테스트 시작하기'" :btnClass="'test-clear on'" @click="onClickGoUt"/>
      <p>담당자 연락처 : {{utData.contact}}</p>
    </div>
    <!-- <div class="pop-dim">
      <bridge-information-pop/>
    </div> -->
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import ButtonItem from '@/components/ui/button'
import UiCheck from '@/components/ui/UiCheck'
import UiRadio from '@/components/ui/UiRadio'
import { getUt, saveSurvey } from '@/api/ut'
import { create } from 'vue-modal-dialogs'
import BridgeInformationPop from '@/components/layerpop/BridgeInformationPop'

const infoLayer = create(BridgeInformationPop, 'type', 'terms')

export default {
  name: 'Dashboard',
  components: {
    ButtonItem,
    'ui-radio': UiRadio,
    'ui-checkbox': UiCheck
  },
  props: [
    'utid'
  ],
  data () {
    return {
      isLoaded: false,
      isEnd: false,
      utData: null,
      isPrivacyAgree: false,
      isThirdPartyAgree: false,
      saveUtData: null,
      modelError: {
        question: [],
        privacyAgree: false,
        thirdPartyAgree: false
      }
    }
  },
  created () {
    EventBus.$emit('onLoading', false)
    this.getData()
  },
  computed: {
  },
  methods: {
    canSubmit () {
      let bSurveyData = true
      const surveyData = this.saveUtData.surveyData
      this.modelError.privacyAgree = null
      this.modelError.thirdPartyAgree = null
      for (let i = 0, iLen = surveyData.length; i < iLen; i++) {
        if (surveyData[i].toString() === '') {
          this.modelError.question[i] = true
          bSurveyData = false
        } else {
          this.modelError.question[i] = false
        }
      }
      this.modelError.privacyAgree = !this.isPrivacyAgree
      this.modelError.thirdPartyAgree = !this.isThirdPartyAgree
      return this.isPrivacyAgree && this.isThirdPartyAgree && bSurveyData
    },
    async onClickAgreement (type) {
      let terms = this.utData.terms1
      if (type === 'third_checkbox') {
        terms = this.utData.terms2
      }
      const confirmResult = await infoLayer(type, terms)
      if (confirmResult) {
        if (type === 'privacy_checkbox') {
          this.isPrivacyAgree = true
        }
        if (type === 'third_checkbox') {
          this.isThirdPartyAgree = true
        }

        document.querySelector('#' + type).setAttribute('checked', 'checked')
      }
    },
    onClickPrivacyAgree (value) {
      this.isPrivacyAgree = value
    },
    onClickThirdPartyAgree (value) {
      this.isThirdPartyAgree = value
    },
    getData () {
      this.isLoaded = false
      const params = {
        utid: this.utid
      }
      getUt(params).then(data => {
        if (data.success) {
          const result = data.result
          this.utData = result
          this.isLoaded = true

          this.saveUtData = {
            utid: this.utData.utid,
            surveyData: []
          }

          // model data init
          //
          const list = this.utData.surveyInfo.question
          for (let i = 0, iLen = list.length; i < iLen; i++) {
            const item = list[i]
            if (item.itemType === 'checkbox') {
              this.saveUtData.surveyData.push([])
            }
            if (item.itemType === 'radio') {
              this.saveUtData.surveyData.push('')
            }
          }

          if (this.utData.state === 'end' || !this.utData.reportState) {
            this.isEnd = true
          }
        } else {
          alert('없는 페이지입니다.')
        }
      }).catch(() => {
        this.$router.replace('/not-found')
      })
    },
    onClickGoUt () {
      if (!this.canSubmit()) {
        return
      }
      // surveyData에서 array 또는 number로 되어 있는 item 들을
      // string으로 변환
      const saveUtData = JSON.parse(JSON.stringify(this.saveUtData))
      const surveyData = saveUtData.surveyData
      for (let i = 0, iLen = surveyData.length; i < iLen; i++) {
        surveyData[i] = surveyData[i].toString()
      }

      saveSurvey(saveUtData).then(data => {
        if (data.success) {
          window.location.href = data.result.redirect_url
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  margin: 90px auto 0;
  padding-bottom: 160px;

  & > h1 {
    width: 990px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    margin: 0 auto;
  }

  .bridge-content {
    width: 990px;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.10), 0 0 0 1px rgba(0, 0, 0, 0.10);
    background: #fff;
    padding: 60px 60px 70px;
    box-sizing: border-box;
    margin: 15px auto 0;

    h2 {
      font-size: 24px;
      font-weight: bold;
      color: #1990c2;
      padding-bottom: 10px;
      border-bottom: 5px solid #1990c2;
    }

    h5 {
      font-size: 14px;
      line-height: 1.57;
      color: #444;
      font-weight: bold;
      margin: 50px 0 0 0;
    }

    p {
      font-size: 14px;
      line-height: 1.57;
      color: #444;
      margin-top: 20px;
      ::v-deep img {
        max-width: 100%;
      }
    }

    .visual-cont {
      width: 640px;
      height: 640px;
      background: #d8d8d8;
      margin: 40px auto 0;
    }

    .question-cont {
      margin-top: 120px;

      h5 {
        position: relative;
        font-size: 20px;
        line-height: 1.6;
        color: #333;
        font-weight: normal;
        padding-left: 30px;
        margin-bottom: 35px;

        &.mT100 {
          margin-top: 100px;
        }

        span {
          display: block;
          position: absolute;
          left: 0;
        }
      }
      .error-txt {
        font-size: 12px;
        font-weight: 500;
        color: #e60724;
      }
    }

    .information-cont {
      position: relative;
      width: 100%;
      height: 155px;
      border-radius: 8px;
      border: solid 1px #ccc;
      background-color: #f7f7f7;
      margin-top: 50px;
      padding: 20px 210px 0;
      box-sizing: border-box;
      .error-txt {
        position: absolute;
        bottom: -25px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 12px;
        font-weight: 500;
        color: #e60724;
      }

      ul {
        li {
          position: relative;
          padding-bottom: 5px;
        }
      }
    }

    .cont-none {
      text-align: center;
      padding: 120px 0;

      h2 {
        display: none;
      }

      h3 {
        margin-top: 25px;
        font-size: 24px;
        font-weight: 500;
        line-height: 1.33;
        color: #333;
      }

      p {
        font-size: 14px;
        line-height: 1.57;
        color: #666;
        margin-top: 10px;
        padding: 0 20px;
        box-sizing: border-box;
      }
    }
  }

  .btn-clear-position {
    margin-top: 40px;
    text-align: center;

    p {
      font-size: 14px;
      line-height: 1.57;
      text-align: center;
      color: #444;
      margin-top: 25px;
    }
  }

  .pop-dim {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100vh;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);;
  }
}

@media all and (max-width: 990px) {
  .add {
      & > h1 {
          width: calc(100% - 40px);
      }
      .bridge-content {
          position: relative;
          width: calc(100% - 40px);
          height: auto;
          .information-cont {
            width: 100%;
            padding: 20px 100px 0;
            box-sizing: border-box;
          }
      }
  }
}

@media all and (max-width: 768px) {
  .add {
    margin: 0px auto 0;
    background: #fff;
    border-top: 1px solid #d7d7d7;
    padding-top: 50px;

    & > h1 {
      width: 100%;
      font-size: 28px;
      text-align: center;
      padding: 0 20px;
      line-height: 40px;
      box-sizing: border-box;
    }

    .bridge-content {
      position: relative;
      width: 100%;
      height: auto;
      border-radius: 0;
      box-shadow: none;
      padding: 0 20px;
      margin: 40px auto 0;

      h2 {
        position: relative;
        height: 20px;
        font-size: 16px;
        padding-bottom: 0;
        border-bottom: none;
        text-align: center;
        margin: 0 auto;
        top: 0;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 100%;
          height: 2px;
          background: #1990c2;
        }

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          display: inline-block;
          padding: 0 15px;
          background: #fff;
          z-index: 1;
        }
      }

      h5 {
        margin: 40px 0 0 0;
      }

      p {
        line-height: 22px;
      }

      .visual-cont {
        width: 100%;
        height: 335px;
        margin: 30px auto 0;
      }

      .question-cont {
        margin-top: 100px;

        h5 {
          position: relative;
          font-size: 20px;
          line-height: 1.6;
          color: #333;
          font-weight: normal;
          padding-left: 0px;
          margin-bottom: 35px;

          &.mT100 {
            margin-top: 80px;
          }

          span {
            display: block;
            position: inherit;
            margin-bottom: 10px;
          }
        }
      }

      .information-cont {
        width: calc(100% + 40px);
        height: 118px;
        border-radius: 0px;
        margin-top: 100px;
        margin-left: -20px;
        padding: 7px 15px 0 20px;
        box-sizing: border-box;
        border: none;
        border-top: solid 1px #ccc;
        border-bottom: solid 1px #ccc;

        ul {
          li {
            position: relative;
            padding-bottom: 5px;
          }
        }
      }

      .cont-none {
        text-align: center;
        padding: 120px 0;

        h2 {
          position: inherit;
          height: auto;
          display: block;
          font-size: 26px;
          font-weight: 500;
          line-height: 1.31;
          text-align: center;
          color: #333;
          margin-bottom: 20px;

          &::after {
            display: none;
          }
        }

        h3 {
          margin-top: 25px;
          font-size: 24px;
          font-weight: 500;
          line-height: 1.33;
          color: #333;
        }

        p {
          font-size: 14px;
          line-height: 1.57;
          color: #666;
          margin-top: 10px;
        }
      }
    }

    .btn-clear-position {
      position: relative;
      margin: 25px 0 20px;
      padding-top: 50px;
      text-align: center;

      p {
        width: 100%;
        padding: 0 40px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 14px;
        line-height: 1.57;
        text-align: center;
        color: #444;
        margin-top: 0;
        box-sizing: border-box;
      }
    }
  }
}
</style>
